import {observer} from 'mobx-react';
import UI from '../stores/UI';
import CONTENT from '../stores/Content';
import Picture from '../components/Picture';
import Sheet from '../components/Sheet';
import Marque from '../components/Marque';
import Markdown from '../components/Markdown';

const Cover = () => {

  return (
    <Sheet order={0} className={'bg-green'}>
      <div className="rel fs h100 guttersx2 padx4 center--spaced">
        <h1 className="logotype txt-c outerx4">
          <div className="works-by">Works by</div>
          <div className="madge-gill">Madge Gill</div>
        </h1>
        <div className="cover">
          <Picture className="multiply" width={800} src="https://images.contentful.com/nniu166iezwv/6P2zvQjVu0qO8sCoWiWSiu/ce3b4a2ed9c715311b739e4fe5d0de44/MADGE_GILL_BLUE_PLAQUE_IMAGE.jpg" />
        </div>
        <div className="outerx4 txt-c">
          <Marque />
        </div>
        <div className="cover-down-arr darr" />
      </div>
      {CONTENT.general ? (
        <div className="about innerx4">
          <h5 className="outerx2 txt-c">{CONTENT.general.aboutSubheader}</h5>
          <div>
            <article>
              <hgroup className="headline max middle guttersx4 outerx8">
                <h1>{CONTENT.general.aboutHeadline}</h1>
              </hgroup>
              <Markdown className="max middle guttersx4 outerx8 indented" convert={CONTENT.general.aboutCopy} />
            </article>
          </div>
        </div>
      ) : null}

    </Sheet>
  )
}

export default observer(Cover)



// WEBPACK FOOTER //
// ./app/javascript/packs/pages/Cover.js